import { render, staticRenderFns } from "./ManagerAdmin.vue?vue&type=template&id=cf16f0ae&"
import script from "./ManagerAdmin.vue?vue&type=script&lang=js&"
export * from "./ManagerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports